import { update } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { RemoveFromDirectAudienceFulfilledAction } from '../../domains/leadersManagement/actions.types';

import type { UserDirectAudiences } from './types';

export type UserDirectAudienceActions = RemoveFromDirectAudienceFulfilledAction;

const initialState: UserDirectAudiences = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const stateWithRemoveFromDirectAudienceFulfilled = (
  state: UserDirectAudiences,
  { userId, audienceMemberIds, suggestedAutocompleteFilter }: RemoveFromDirectAudienceFulfilledAction['payload']
): UserDirectAudiences => {
  const fulfilledUserDirectAudience = state.fulfilled.byId[userId];

  if (fulfilledUserDirectAudience) {
    const directAudiences = fulfilledUserDirectAudience.directAudiences.filter(
      ({ id }) => !audienceMemberIds.includes(id)
    );
    const updatedDirectAudience = {
      directAudiences,
      suggestedAutocompleteFilter,
    };

    return update(state, userId, updatedDirectAudience);
  }

  return state;
};

const reducer: Reducer<UserDirectAudiences, UserDirectAudienceActions> = (state = initialState, action) => {
  switch (action.type) {
    case 'REMOVE_FROM_DIRECT_AUDIENCE.FULFILLED':
      return stateWithRemoveFromDirectAudienceFulfilled(state, action.payload);
    default:
      return state;
  }
};

export default reducer;
